import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    availableContext: 2048,
};
export const memorySlice = createSlice({
    name: "memory",
    initialState,
    reducers: {
        setContextMemory: (state, action) => {
            state.availableContext = action.payload.availableContext;
        },
    },
});
export const { setContextMemory } = memorySlice.actions;
export default memorySlice.reducer;
